import { jsxs as m, jsx as n, Fragment as A } from "react/jsx-runtime";
import { useState as z } from "react";
import { useBreakpoint as L, useTranslation as W, Breakpoints as V, useNextgenRouter as I, useSession as Y, NextgenImage as y, LoaderType as N, GenericLink as v } from "@nextgen-web-framework/all";
import M from "../SkeletonLoader/SkeletonLoader.js";
import { getGradientClass as j } from "../../utils/themeColor.js";
import { createDynamicUrl as H } from "../../utils/dynamicUrlGenerator.js";
import '../../assets/ImagesAndLinksContainer.css';const D = "#ffffff", E = "#396e75", K = "#e5fdff", U = "#546223", F = "#f0fae5", X = "#a65523", J = "#fff1e8", P = "#7f3e3e", Q = "#ffe2e2", Z = "#62625a", q = "#f8f8e7", ee = "#38539a", te = "#707070", ae = "#c8f8d1", re = "#87c9c8", oe = "#5291b1", ne = "rgba(82, 145, 177, 0.1019607843)", ie = "#445685", le = "#181d61", de = "rgba(24, 29, 97, 0.1019607843)", se = "#5969d6", ce = "#ea999d", ge = "#b6577e", _e = "rgba(182, 87, 126, 0.1019607843)", me = "#7e3e80", ue = "#1e247f", he = "rgba(30, 36, 127, 0.1019607843)", be = "#da7600", fe = "#107f47", ke = "#d91734", pe = "_html_1fobu_38", Ce = "_list_1fobu_297", ze = "_open_1fobu_443", o = {
  amwayWhite: D,
  darkBlue: E,
  lightBlue: K,
  darkGreen: U,
  lightGreen: F,
  darkOrange: X,
  lightOrange: J,
  darkRed: P,
  lightRed: Q,
  darkYellow: Z,
  lightYellow: q,
  darkPurple: ee,
  darkGrayOnWhite: te,
  dataVizColor1: ae,
  dataVizColor2: re,
  dataVizColor3: oe,
  dataVizColor3Background: ne,
  dataVizColor4: ie,
  dataVizColor5: le,
  dataVizColor5Background: de,
  dataVizColor6: se,
  dataVizColor7: ce,
  dataVizColor8: ge,
  dataVizColor8Background: _e,
  dataVizColor9: me,
  dataVizColor10: ue,
  dataVizColor10Background: he,
  dataVizAlertOrange: be,
  dataVizSuccessGreen: fe,
  dataVizWarningRed: ke,
  "no-visible": "_no-visible_1fobu_34",
  html: pe,
  "theme-border-dark-red": "_theme-border-dark-red_1fobu_143",
  "theme-border-dark-blue": "_theme-border-dark-blue_1fobu_147",
  "theme-border-dark-orange": "_theme-border-dark-orange_1fobu_151",
  "theme-border-dark-green": "_theme-border-dark-green_1fobu_155",
  "theme-border-dark-purple": "_theme-border-dark-purple_1fobu_159",
  "theme-border-dark-gray": "_theme-border-dark-gray_1fobu_163",
  "theme-border-light-red": "_theme-border-light-red_1fobu_167",
  "theme-border-light-blue": "_theme-border-light-blue_1fobu_171",
  "theme-border-light-orange": "_theme-border-light-orange_1fobu_175",
  "theme-border-light-green": "_theme-border-light-green_1fobu_179",
  "theme-border-light-purple": "_theme-border-light-purple_1fobu_183",
  "theme-border-light-gray": "_theme-border-light-gray_1fobu_187",
  "theme-gradient-red": "_theme-gradient-red_1fobu_191",
  "theme-gradient-blue": "_theme-gradient-blue_1fobu_195",
  "theme-gradient-orange": "_theme-gradient-orange_1fobu_199",
  "theme-gradient-green": "_theme-gradient-green_1fobu_203",
  "theme-gradient-purple": "_theme-gradient-purple_1fobu_207",
  "images-with-links-container": "_images-with-links-container_1fobu_256",
  "category-container": "_category-container_1fobu_266",
  "image-container": "_image-container_1fobu_270",
  "category-image": "_category-image_1fobu_273",
  "image-text": "_image-text_1fobu_284",
  list: Ce,
  "list-item": "_list-item_1fobu_304",
  "blue-gradient": "_blue-gradient_1fobu_316",
  "green-gradient": "_green-gradient_1fobu_319",
  "orange-gradient": "_orange-gradient_1fobu_322",
  "gray-gradient": "_gray-gradient_1fobu_325",
  "red-gradient": "_red-gradient_1fobu_328",
  "images-and-links-container": "_images-and-links-container_1fobu_359",
  "images-and-links-container-heading": "_images-and-links-container-heading_1fobu_359",
  "images-and-links-container-items": "_images-and-links-container-items_1fobu_367",
  "images-container": "_images-container_1fobu_376",
  "item-image-container": "_item-image-container_1fobu_385",
  "text-container": "_text-container_1fobu_402",
  "section-link-item-container": "_section-link-item-container_1fobu_431",
  open: ze,
  "fade-in": "_fade-in_1fobu_1"
}, w = (l, s, c, i) => i != null && i.length ? H(l, i, s, c) : l || "", Ge = (l) => {
  const [s, c] = z(), i = L(), B = W(), u = [V.SM, V.XS].includes(i), [G, S] = z({}), h = I(), { session: b } = Y(), T = (e) => {
    S((t) => ({
      ...t,
      [`${e}`]: !1
    }));
  }, f = (e) => e.linearGradient ? j(e.linearGradient) : `${e.overlayGradient}-gradient`, $ = (e = [], t, a) => {
    const r = [...e];
    return u && t && r.unshift({
      title: B("web.megamenu.viewAll"),
      url: t,
      target: a
    }), r;
  }, k = (e = []) => /* @__PURE__ */ n("ul", { className: `${o.list} ${o.open}`, children: e.map((t) => {
    var r;
    const a = w(
      t.url,
      (r = h.params) == null ? void 0 : r.locale,
      b.aboNum,
      t.queryParams
    );
    return /* @__PURE__ */ n("li", { className: o["list-item"], children: /* @__PURE__ */ n(
      v,
      {
        className: o["section-link-item-container"],
        href: a,
        forceNative: !1,
        target: t.target,
        children: t.title
      }
    ) }, t.title);
  }) }), O = (e, t) => {
    s === t ? c("") : (c(t), setTimeout(() => {
      const a = e.target, r = document.querySelectorAll(
        '#mobile-topbar-navigation-header, [class*="shop-by-page-navigator"]'
      ), d = Array.from(r).reduce(
        (_, R) => _ + R.offsetHeight,
        0
      ), g = a.getBoundingClientRect().top + window.scrollY - d;
      window.scrollTo({
        top: g,
        behavior: "smooth"
      });
    }, 100));
  }, p = (e) => {
    var a;
    const t = (a = e == null ? void 0 : e.imageList) == null ? void 0 : a.find((r) => r.viewport.includes(i));
    return t == null ? void 0 : t.url;
  }, C = (e, t, a) => {
    const r = a ? { visibility: "hidden" } : {};
    return /* @__PURE__ */ m(A, { children: [
      /* @__PURE__ */ n(
        y,
        {
          className: "lazy-image-and-link",
          src: p(e) ?? "",
          alt: e.title,
          style: r,
          onLoad: () => T(t),
          loaderType: N.CONTENTSTACK
        },
        `${e.title}`
      ),
      a && /* @__PURE__ */ n(M, { height: 120, borderRadius: 12 }),
      /* @__PURE__ */ n("span", { style: r, className: `${o["image-text"]} ${o[f(e)]}`, children: e.title })
    ] });
  }, x = (e, t, a) => {
    var d, g, _;
    const r = w(((d = e.link) == null ? void 0 : d.url) || "", (g = h.params) == null ? void 0 : g.locale, b.aboNum, e.queryParams);
    return /* @__PURE__ */ m("div", { className: o["category-container"], children: [
      /* @__PURE__ */ n("div", { className: o["image-container"], "data-testid": `images-data-test-id-${t}`, children: (_ = e == null ? void 0 : e.link) != null && _.url ? /* @__PURE__ */ n(v, { href: r, className: o["category-image"], target: e.link.target, children: C(e, t, a) }) : /* @__PURE__ */ n("div", { className: o["category-image"], children: C(e, t, a) }) }),
      k(e.subCategories)
    ] }, e.title);
  };
  return u ? (
    // Mobile View
    /* @__PURE__ */ m("div", { className: o["images-and-links-container"], "data-testid": "menu-images-with-links-mobile-id", "data-pod-name": "commerce", children: [
      /* @__PURE__ */ n("h4", { className: o["images-and-links-container-heading"], children: l.allTitle }),
      /* @__PURE__ */ n("div", { className: o["images-and-links-container-items"], children: l.categories.map((e, t) => {
        var a, r;
        return /* @__PURE__ */ m(
          "div",
          {
            className: `${o["images-container"]}`,
            "data-testid": `images-data-test-id-${t}`,
            role: "presentation",
            onClick: (d) => O(d, e.title),
            children: [
              /* @__PURE__ */ n("div", { className: o["item-image-container"], children: /* @__PURE__ */ n(
                y,
                {
                  className: o["category-image"],
                  src: p(e) ?? "",
                  alt: e.title,
                  loaderType: N.CONTENTSTACK
                },
                `${e.title}`
              ) }),
              /* @__PURE__ */ n("span", { className: `${o["text-container"]} ${o[f(e)]}`, children: e.title }),
              s === e.title && k($(e.subCategories, (a = e.link) == null ? void 0 : a.url, (r = e.link) == null ? void 0 : r.target))
            ]
          },
          e.title
        );
      }) })
    ] })
  ) : (
    // Desktop/Tablet View
    /* @__PURE__ */ n("div", { className: o["images-with-links-container"], "data-testid": "menu-images-with-links-id", "data-pod-name": "commerce", children: l.categories.map((e, t, a) => {
      const r = Object.keys(G).length !== a.length;
      return x(e, t, r);
    }) })
  );
};
export {
  Ge as default
};
//# sourceMappingURL=ImagesAndLinksContainer.js.map
